import { BudgetSections } from 'business/constants';
import { snakify } from 'helpers/syntaxHelper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import * as Sentry from '@sentry/browser';
import { BudgetT } from 'routes/BudgetModule/config/types';
import {
    BUDGET_CODE_FIELD,
    BUDGET_NAME_FIELD,
} from 'routes/BudgetModule/config/constants';
import { BPCreationSummary } from './types';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';

type BpT = {
    name: string;
    code: string;
    section: string | null;
};

export const useCreateBP = (
    isSchool?: boolean,
    exercice?: number,
    by?: string,
    phase?: string,
    bCodes?: BudgetT[],
) => {
    const queryClient = useQueryClient();
    const { budgetProposalsKeys } = createBudgetQueryKeys();
    const budgetProposals: BpT[] = [];
    if (!isSchool) {
        bCodes?.forEach((x) => {
            budgetProposals.push({
                name: x[BUDGET_NAME_FIELD],
                code: x[BUDGET_CODE_FIELD],
                section: BudgetSections.INVESTMENT,
            });
            budgetProposals.push({
                name: x[BUDGET_NAME_FIELD],
                code: x[BUDGET_CODE_FIELD],
                section: BudgetSections.OPERATING,
            });
        });
    } else {
        bCodes?.forEach((x) => {
            budgetProposals.push({
                name: x[BUDGET_NAME_FIELD],
                code: x[BUDGET_CODE_FIELD],
                section: null,
            });
        });
    }

    return useMutation({
        mutationFn: async () => {
            if (
                by === undefined ||
                exercice === undefined ||
                phase === undefined ||
                bCodes === undefined
            ) {
                Sentry.captureException(
                    new Error(
                        `Hook useCreateBP being called with invalid arguments: ${by}, ${exercice}, ${phase}, ${bCodes}`,
                    ),
                );
                return null;
            }
            const response = await RQAPICallWithData<BPCreationSummary>({
                endpoint: `budget_proposals/bulk_create`,
                method: 'POST',
                body: {
                    exercice,
                    by: snakify(by),
                    phase,
                    budgetProposals,
                },
            });
            return response.content.data;
        },

        onSuccess: () => {
            // TODO / DEBT: @Bumba Migration React Query v3 -> v4, si budgetProposalsKeys est un array
            // est-ce que l'on ne peut pas l'utiliser directement, ou y a t'il un interet a ne prendre que
            // [0] ?
            // On invalidate la query dans:
            // src/routes/Admin/Budget/BudgetManagement/BudgetList/CellRenderers/PhaseEditorCellRenderers/NextBudgetPhase.tsx(101,47)
            queryClient.invalidateQueries({
                queryKey: [budgetProposalsKeys()[0]],
            });
        },

        meta: {
            useGlobalOnError: true,
        },
    });
};
